export function tryConcat<T>(...arrays: (T[] | undefined)[]): T[] {
    return arrays.reduce<T[]>(
        (acc, array) => (array ? [ ...acc, ...array ] : acc),
        []
    );
}
